<template>
  <div class="car-unpetrified-com">
    <div class="header">
      <el-form :inline="true" :model="formData">
        <!-- <el-form-item label="" label-width="75px" v-if="username">
          <el-input v-model="formData.cmpnanyDevUser" clearable placeholder="请输入开发人"></el-input>
        </el-form-item> -->
        <el-form-item label="开发状态" label-width="75px">
          <el-select v-model="formData.devStatus" placeholder="请选择">
            <el-option
              v-for="item in devStatusOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省市区" label-width="75px">
          <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
          <el-cascader
            v-if="areaListPr.length > 0"
            :options="areaListPr"
            v-model="formData.provCityCounty"
            :props="propsData()"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="终止开发原因" label-width="110px">
          <el-cascader
            v-model="formData.failedType"
            placeholder="请选择终止开发原因"
            style="width: 250px"
            :options="failedTypeOptionT"
            :props="{ expandTrigger: 'hover' }"
            clearable
          >
          </el-cascader>
        </el-form-item>
        <template v-if="value1">
          <el-form-item label="客户状态" label-width="75px">
            <el-select
              v-model="formData.companyCardStatus"
              multiple
              collapse-tags
              style="width: 250px"
              placeholder="请选择"
            >
              <el-option
                v-for="item in companyCardStatusOptionNew"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月柴油消耗量估算" label-width="130px">
            <el-select
              v-model="formData.oilConsumptionMask"
              placeholder="不限"
              style="width:150px;"
            >
              <el-option
                v-for="item in oilConsumptionRangeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="停靠石化油站次数占比">
            <el-select
              v-model="formData.percentage"
              placeholder="不限"
              style="width:110px;"
            >
              <el-option label="不限" value></el-option>
              <el-option
                v-for="item in petrochemicalStopRadioOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开发开始时间" label-width="110px">
            <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
            <el-date-picker
              v-model="formData.selectDateVal"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="开发结束时间" label-width="110px">
            <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
            <el-date-picker
              v-model="formData.selectDateVal2"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <!--          <el-form-item label="" label-width="75px">-->
          <!--            &lt;!&ndash;            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>&ndash;&gt;-->
          <!--formData          </el-form-item>-->
        </template>
        <el-button @click="onSearch(null)" class="searchBtn">查询</el-button>
        <el-button 
          @click="handleBatchReturn" 
          :disabled="selectedRows.length === 0"
          style="margin-left: 10px"
        >
          批量退回
        </el-button>
        <el-form-item>
          <el-switch
            v-model="value1"
            style="margin-left: 10px"
            @change="changeSearch"
            active-text="展开"
            inactive-text="收起"
          >
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <main>
      <el-table 
        ref="table"
        :data="tableData" 
        :max-height="tableHeight1" 
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          fixed
          type="index"
          width="50"
          align="center"
          label="序号"
        ></el-table-column>
        <el-table-column
          prop="companyName"
          width="200"
          fixed
          label="企业名称"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.decryptedCompanyName">{{
              scope.row.companyName
            }}</span>
            <el-tooltip v-else placement="top" content="点击解密">
              <span
                style="cursor: pointer"
                @click="scope.row.decryptedCompanyName = true"
                >{{ scope.row.companyNameMask }}</span
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="otherStopCount"
          width="150"
          align="center"
          label="更多"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.companyAddress == null">-</span>
            <span
              v-else
              style="color:#1137FF;cursor: pointer;"
              @click="toDetail(scope.row)"
              >查看</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="isRecord"
          width="150"
          align="center"
          label="开发记录"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.isRecord === 1"
              style="color:#1137FF;cursor: pointer;"
              @click="seeDevLog(scope.row)"
              >查看</span
            >
            <span v-else>-</span>
            <!--            <span style="color:#1137FF;cursor: pointer;" @click="seeDevLog(scope.row)">查看</span>-->
          </template>
        </el-table-column>
        <el-table-column
          prop="companyCreditCode"
          width="200"
          label="统一社会信用代码"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.companyCreditCodeIs">{{
              scope.row.companyCreditCode
            }}</span>
            <el-tooltip v-else placement="top" content="点击解密">
              <span
                style="cursor: pointer"
                @click="scope.row.companyCreditCodeIs = true"
                >{{ scope.row.companyCreditCodeMask }}</span
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="oilConsumption"
          label="柴油量估算(吨)"
          width="150"
          align="center"
        >
          <template slot="header" slot-scope="scope">
            <el-popover placement="bottom" width="400" trigger="hover">
              <div class="proTextSty">
                根据企业名下所有运营柴油车辆对应吨位百公里油耗，乘以相应运营里程计算得出。1吨=1176升。下附车型油耗表。
              </div>
              <div class="tableTitleSty">车型油耗表</div>
              <el-table :data="gridData" border>
                <el-table-column
                  width="185"
                  align="center"
                  property="date"
                  label="车辆吨位区间"
                ></el-table-column>
                <el-table-column
                  align="center"
                  property="name"
                  label="平均每百公里油耗(升)"
                ></el-table-column>
              </el-table>
              <span slot="reference">
                <span style="margin-right: 5px">柴油量估算(吨)</span>
                <i class="el-icon-info"></i>
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="vehicleOperatorCount"
          label="运营车辆数"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="petrochemicalStopRadio"
          label="停靠石化油站次数占比"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.petrochemicalStopRadio &&
              scope.row.petrochemicalStopRadio != '-'
                ? scope.row.petrochemicalStopRadio + '%'
                : scope.row.petrochemicalStopRadio
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="petrochemicalStopRadio"
          label="停靠石化油站次数环比"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.petrochemicalStopRadioMom &&
              scope.row.petrochemicalStopRadioMom != '-'
                ? scope.row.petrochemicalStopRadioMom + '%'
                : scope.row.petrochemicalStopRadioMom
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="petrochemicalStopCount"
          label="S级油站停靠次数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="petroleumStopCount"
          label="C级油站停靠次数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="otherStopCount"
          label="E级油站停靠次数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cardTypeText"
          label="加油卡类型"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cardCount"
          label="联名卡办卡数量"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="lastOpetime"
          label="最后一次联名卡消费时间"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          prop=""
          label="近6个月平均消费"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="otherStopCount"
          width="250"
          align="center"
          label="办卡信息"
        >
          <template slot-scope="scope">
            <!--            <span v-if="scope.row.cardType == '3'">-</span>-->
            <span v-if="scope.row.cardType == '3'">-</span>
            <div v-else>
              <span
                :style="{
                  color: scope.row.devUser != username ? '#c0c4cc' : '#1137FF',
                  cursor: 'pointer',
                  marginRight: '10px'
                }"
                @click="editRow(scope.row, 1)"
                >联名卡修改</span
              >
              <span
                :style="{
                  color: scope.row.devUser != username ? '#c0c4cc' : '#1137FF',
                  cursor: 'pointer'
                }"
                @click="editRow(scope.row, 2)"
                >普通卡修改</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="provname"
          label="所属省份"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cityname"
          label="所属城市"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="countyname"
          label="所属区县"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="runProvince"
          label="常运营省份按里程取TOP3"
          width="250"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="runProvince"
          label="停靠加油站TOP5"
          width="250"
          align="center"
        >
          <template slot-scope="scope">
            <!--            <span v-if="scope.row.companyAddress==null">-</span>-->
            <!--            <span v-else style="color:#1137FF;cursor: pointer;" @click="toDetail(scope.row)">查看</span>-->
            <span
              style="color:#1137FF;cursor: pointer;"
              @click="seeTopFive(scope.row)"
              >查看</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="companyCardStatusText"
          label="客户状态"
          width="170"
          align="center"
        >
          <template slot="header" slot-scope="scope">
            <el-popover placement="bottom" width="400" trigger="hover">
              <div class="proTextSty">
                联名卡在用客户：近6个自然月有联名卡消费或有新增办卡的客户，对于非联名卡在用客户将根据其名下车辆停靠中国石化加油站占比区间定义客户状态为潜在新客户[0~10%)，摇摆客户[10%~20%)，低忠诚客户[20%~30%)，中忠诚客户[30%~50%)，高忠诚客户[50%~100%]。
              </div>
              <span slot="reference">
                <span style="margin-right: 5px">客户状态</span>
                <i class="el-icon-info"></i>
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="companyDevStatusText"
          label="开发状态"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="devUser"
          label="开发人"
          align="center"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="cmpnanyDevStartTime"
          width="150"
          label="开发开始时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="cmpnanyDevEndTime"
          width="150"
          label="开发结束时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="failedTypeText"
          width="170"
          label="开发失败原因"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="failedRemark"
          width="170"
          label="开发失败备注"
          show-overflow-tooltip
          align="center"
        ></el-table-column>
        <el-table-column
          prop="reachStatusText"
          label="车机触达"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="vehicleCountMask"
          label="车辆规模"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="mileageMask"
          label="运营公里数"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="provname"
          fixed="right"
          width="250"
          align="center"
          label="开发结束资料"
        >
          <template slot-scope="scope">
            <div class="benAllSty">
              <div v-if="scope.row.devStatus == 0" class="itemDiv">
                <el-button
                  :key="scope.row.devStatus"
                  style="width: 112px"
                  v-if="scope.row.devStatus == 0"
                  @click="showMes(scope.row, '修改')"
                >
                  修改资料
                </el-button>
              </div>
              <div v-else class="itemDiv">
                <el-button
                  :key="scope.row.receiveStatus"
                  style="width: 112px"
                  v-if="scope.row.receiveStatus == 1"
                  @click="showMes(scope.row, '补充')"
                >
                  待补充资料
                </el-button>
                <el-button :key="scope.row.receiveStatus" v-else disabled
                  >已补充资料</el-button
                >
              </div>
              <el-button
                :disabled="scope.row.receiveStatus == 1"
                @click="seeRow(scope.row)"
              >
                查看
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="provname"
          fixed="right"
          width="150"
          align="center"
          label="退订任务"
        >
          <template slot-scope="scope">
            <el-button
              :key="scope.row.devStatus"
              type="danger"
              v-if="
                scope.row.devStatus == 2 &&
                  !is7day(scope.row) &&
                  scope.row.devUser == username
              "
              @click="closePro(scope.row)"
              >退订任务
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <div class="block">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        :page-sizes="[50, 100, 200]"
        layout="prev, pager, next, jumper, sizes"
        :total="total"
        style="margin:auto;"
      ></el-pagination>
    </div>

    <el-dialog
      title="更多"
      v-if="dialogFormVisible"
      :close-on-click-modal="false"
      width="808px"
      :visible.sync="dialogFormVisible"
    >
      {{ adr }}<br />
      {{ phone }}
    </el-dialog>
    <el-dialog
      title="提示"
      v-if="dialogFormVisible3"
      :close-on-click-modal="false"
      width="500px"
      :visible.sync="dialogFormVisible3"
    >
      <p>退订后，此任务将从目标客户列表中删除，是否确定要退订？</p>
      <div slot="footer" class="dialog-footer">
        <div class="btn_Sub" @click="closeTask()">确 定</div>
        <div class="btn_Clo" @click="dialogFormVisible3 = false">取 消</div>
      </div>
    </el-dialog>
    <el-dialog
      title="开发结束资料补充"
      v-if="dialogFormVisible2"
      :close-on-click-modal="false"
      width="808px"
      :visible.sync="dialogFormVisible2"
    >
      <el-form
        ref="form"
        class="formSty"
        :inline="true"
        label-position="top"
        :rules="rules"
        :model="form"
      >
        <el-form-item label="客户名称" prop="companyNameMask">
          <el-tooltip placement="top" content="点击解密">
            <div @click="showVal('companyNameMask', 'companyName')">
              <el-input
                v-model="form.companyNameMask"
                disabled
                style="pointer-events: none;width: 357px;"
                placeholder="请输入客户名称"
              ></el-input>
            </div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="companyCreditCodeMask">
          <el-tooltip placement="top" content="点击解密">
            <div @click="showVal('companyCreditCodeMask', 'companyCreditCode')">
              <el-input
                v-model="form.companyCreditCodeMask"
                :disabled="true"
                placeholder="请输入统一社会信用代码"
                style="width: 357px;pointer-events: none;"
              ></el-input>
            </div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="所属省份" prop="pr">
          <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属省/市/县" style="width: 357px"></el-input>-->
          <el-select
            v-model="form.pr"
            disabled
            @change="prChange"
            style="width: 357px"
            placeholder="请选择所属省份"
          >
            <el-option
              v-for="item in proptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属城市" prop="ci">
          <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属省/市/县" style="width: 357px"></el-input>-->
          <el-select
            v-model="form.ci"
            disabled
            @change="ciChange"
            style="width: 357px"
            placeholder="请选择所属城市"
          >
            <el-option
              v-for="item in cioptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属区县" prop="cu">
          <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属区县" style="width: 357px"></el-input>-->
          <el-select
            v-model="form.cu"
            disabled
            style="width: 357px"
            placeholder="请选择所属区县"
          >
            <el-option
              v-for="item in cuoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="客户标签" prop="companyLabel">
          <el-select
            v-model="form.companyLabel"
            style="width: 357px"
            placeholder="请选择客户标签"
          >
            <el-option
              v-for="item in companyLabelOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否开发成功" prop="devSuccess">
          <el-select
            v-model="form.devSuccess"
            @change="changeIs"
            style="width: 357px"
            placeholder="请选择是否开发成功"
          >
            <el-option
              v-for="item in devSuccessOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="form.devSuccess == '0'">
          <el-form-item label="开发失败原因" prop="failedType">
            <!--            <el-select v-model="form.failedType" style="width: 357px"-->
            <!--                       placeholder="请选择开发失败原因">-->
            <!--              <el-option-->
            <!--                  v-for="item in failedTypeOptionT"-->
            <!--                  :key="item.value"-->
            <!--                  :label="item.label"-->
            <!--                  :value="item.value">-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <el-cascader
              v-model="form.failedType"
              placeholder="请选择开发失败原因"
              style="width: 357px"
              :options="failedTypeOptionT"
              :props="{ expandTrigger: 'hover' }"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="备注" prop="remarkerr">
            <el-input
              v-model="form.remarkerr"
              type="textarea"
              placeholder="请说明具体失败情况"
              maxlength="1000"
              :rows="2"
              style="width: 746px"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="form.devSuccess == '1'">
          <el-form-item label="客户姓名" prop="contactName">
            <el-input
              v-model="form.contactName"
              maxlength="20"
              placeholder="请输入客户姓名"
              style="width: 357px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户手机号码" prop="contactPhone">
            <el-input
              v-model="form.contactPhone"
              placeholder="请输入客户手机号码"
              style="width: 357px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="开卡状态" prop="cardType">
            <el-select
              v-model="form.cardType"
              style="width: 357px"
              @change="changeData()"
              placeholder="请选择"
            >
              <el-option
                v-for="item in optionsCommonCardStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="form.cardType == 1"
            label="联名卡主卡卡号"
            prop="qqq"
          >
            <!--            <el-select v-model="form.qqq" style="width: 357px" placeholder="请选择">-->
            <!--              <el-option-->
            <!--                  v-for="item in qqqOption"-->
            <!--                  :key="item.value"-->
            <!--                  :label="item.label"-->
            <!--                  :value="item.value">-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <el-autocomplete
              v-model="form.qqq"
              style="width: 357px;"
              :fetch-suggestions="querySearchAsynclmk"
              :maxlength="30"
              placeholder="请输入联名卡卡号"
              @select="handleSelectlmk"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item
            v-if="form.cardType == 2"
            v-for="(domain, index) in form.domains"
            :key="domain.key"
            :label="index == 0 ? '普通卡主卡卡号及有效卡数量' : ''"
            :prop="'domains.' + index"
            :rules="{
              required: true,
              validator: ruleMobile,
              trigger: 'change'
            }"
          >
            <div class="cardMesSty">
              <!--              <el-input style="width: 357px;margin-right: 30px" placeholder="请输入19位卡号" maxlength=19  :fetch-suggestions="querySearchAsync"-->
              <!--                        @select="handleSelect"-->
              <!--                        v-model="domain.value"></el-input>-->
              <el-autocomplete
                v-model="domain.value"
                style="width: 357px;margin-right: 30px"
                :fetch-suggestions="querySearchAsync"
                :maxlength="19"
                placeholder="请输入19位卡号"
                @select="handleSelect"
              ></el-autocomplete>
              <el-input
                style="width: 357px"
                placeholder="请输入有效卡数量"
                v-model="domain.value2"
                maxlength="7"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="是否有专属优惠" prop="vipDiscount">
            <el-select
              v-model="form.vipDiscount"
              style="width: 357px"
              placeholder="请选择是否有专属优惠"
            >
              <el-option
                v-for="item in vipDiscountOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="form.vipDiscount == '1'"
            label="柴油优惠折算金额(元/升)"
            prop="num"
          >
            <el-input-number
              v-model="num"
              :precision="2"
              :step="0.01"
              :min="0"
              :max="3"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            v-if="form.vipDiscount == '1'"
            label="优惠类别"
            prop="discountType"
          >
            <el-select
              v-model="form.discountType"
              style="width: 357px"
              placeholder="请选择优惠类别"
            >
              <el-option
                v-for="item in discountTypeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="form.vipDiscount == '1'"
            label="备注"
            prop="remark"
          >
            <el-input
              v-model="form.remark"
              type="textarea"
              placeholder="请输入具体优惠政策等信息"
              maxlength="1000"
              :rows="2"
              style="width: 746px"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-popconfirm
          title="开发资料一旦提交无法修改，是否确认要提交？"
          @confirm="handleConfirm"
        >
          <div class="btn_Sub" slot="reference">提 交</div>
        </el-popconfirm>
        <div class="btn_Clo" @click="dialogFormVisible2 = false">取 消</div>
      </div>
    </el-dialog>
    <detailCard
      @changeDetail="changeDetail"
      :isEdit="true"
      :cardNum="cardNum"
      :nrData="nrData"
      v-if="isEdit"
    ></detailCard>

    <detailCardGoal
      @changeDetail="changeSeeDetail"
      :nrData="seeDeatailData"
      v-if="isSeeDetail"
    ></detailCardGoal>
    <!--  退订   -->
    <unsubscribe
      @closeTask="closeTask"
      :currRow="currRow"
      v-if="tdIs"
    ></unsubscribe>
    <!--  开发记录   -->
    <devLog
      @closeTask="closeProAll"
      :currRow="currRow"
      :isShowManage="true"
      v-if="devLogIs"
    ></devLog>
    <!--  加油站Top5   -->
    <seeTopFive
      @closeTask="closeProAll"
      :currRow="currRow"
      v-if="seeTopFiveIs"
    ></seeTopFive>
    <!--  批量退回   -->
    <batchReturn
      @closeTask="closeBatchReturn"
      :selectedRows="selectedRows"
      v-if="batchReturnIs"
    ></batchReturn>
  </div>
</template>

<script>
import { hideExport } from '@/utils/tools'
import http from '@/api/freight' // 请求汇总
import _ from 'lodash'
import Util from 'utils/util'
import detailCard from 'components/detailCard.vue'
import unsubscribe from 'components/unsubscribe.vue'
import seeTopFive from 'components/seeTopFive.vue'
import devLog from 'components/devLog.vue'
import detailCardGoal from 'components/detailCardGoal.vue'
import batchReturn from 'components/batchReturn.vue'

// 停靠非石化加油站企业列表
export default {
  name: 'car-unpetrified-com',
  components: { detailCard, detailCardGoal, unsubscribe, devLog, seeTopFive, batchReturn },
  data() {
    return {
      devLogIs: false,
      seeTopFiveIs: false,
      tdIs: false,
      batchReturnIs: false,
      selectedRows: [],
      areaListPr: '',
      tableHeight1: this.tableHeight,
      value1: true,
      nrData: {},
      seeDeatailData: {},
      qqqOption: [],
      rules: {
        companyNameMask: [
          {
            required: true,
            message: '请输入客户名称',
            trigger: 'blur'
          }
        ],
        companyCreditCodeMask: [
          {
            required: true,
            validator: this.companyCred,
            trigger: 'blur'
          }
        ],
        pr: [
          {
            required: true,
            message: '请选择所属省份',
            trigger: 'blur'
          }
        ],
        ci: [
          {
            required: true,
            message: '请选择所属城市',
            trigger: 'blur'
          }
        ],
        cu: [
          {
            required: true,
            message: '请选择所属区县',
            trigger: 'blur'
          }
        ],
        commonCardStatus: [
          { required: true, message: '请选择是否已有普通卡', trigger: 'change' }
        ],
        contactName: [
          {
            required: true,
            message: '请输入客户姓名',
            trigger: 'blur'
          }
        ],
        contactPhone: [
          { required: true, validator: this.rulePhone, trigger: 'blur' }
        ],
        cardType: [
          { required: true, message: '请选择开卡状态', trigger: 'change' }
        ],
        qqq: [
          { required: true, validator: this.ruleMobile2, trigger: 'change' }
        ],
        vipDiscount: [
          { required: true, message: '请选择是否专属优惠', trigger: 'change' }
        ],
        discountType: [
          { required: true, message: '请选择优惠类别', trigger: 'change' }
        ],
        num: [{ required: true, validator: this.numHave, trigger: 'blur' }],
        devSuccess: [
          { required: true, message: '请选择是否开发成功', trigger: 'change' }
        ],
        companyLabel: [
          { required: true, message: '请选择客户标签', trigger: 'change' }
        ],
        failedType: [
          { required: true, message: '请选择失败原因', trigger: 'change' }
        ],
        remark: [
          {
            required: true,
            message: '请输入具体优惠政策等信息',
            trigger: 'blur'
          }
        ],
        remarkerr: [
          {
            required: true,
            message: '请说明具体失败情况',
            trigger: 'blur'
          }
        ]
      },
      proptions: [],
      cioptions: [],
      cuoptions: [],
      optionsCommonCardStatus: [
        {
          value: '1',
          label: '联名卡'
        },
        {
          value: '2',
          label: '普通卡'
        }
      ],
      vipDiscountOption: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '0',
          label: '否'
        }
      ],
      devSuccessOption: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '0',
          label: '否'
        }
      ],
      failedTypeOptionT: Util.failedTypeOptionT,
      discountTypeOption: Util.discountTypeOption,
      companyLabelOption: Util.companyLabelOption,
      num: 0,
      form: {
        companyLabel: '',
        devSuccess: '',
        failedType: '',
        companyNameMask: '',
        companyCreditCodeMask: '',
        pr: '',
        ci: '',
        cu: '',
        commonCardStatus: '',
        contactName: '',
        contactPhone: '',
        cardType: '1',
        qqq: '',
        vipDiscount: '',
        discountType: '',
        remark: '',
        remarkerr: '',
        domains: [
          {
            value: '',
            value2: ''
          }
        ]
      },
      currRow: '',
      isShowInput: false,
      cardNum: '',
      isChangeci: false,
      isChangecu: false,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      gridData: Util.gridData,
      reachStatusOptions: Util.reachStatusOptions,
      companyCardStatusOption: Util.companyCardStatusOption,
      companyCardStatusOptionNew: Util.companyCardStatusOptionNew,
      devStatusOption: Util.devStatusOption310New,
      devLogOption: Util.devLogOption,
      cardTypeOption: Util.cardTypeOption,
      vehicleCountMaskOption: Util.vehicleCountMaskOption,
      mileageMaskOption: Util.mileageMaskOption,
      failedTypeOptionT: Util.failedTypeOptionT,
      oilConsumptionRangeOption: Util.oilConsumptionRangeOption,
      petrochemicalStopRadioOption: Util.petrochemicalStopRadioOption,
      formData: {
        companyCardStatus: [],
        cmpnanyDevUser: '',
        companyName: '',
        provCityCounty: '',
        provCode: '',
        cityCode: '',
        countyCode: '',
        time: '',
        cardType: '',
        vehicleCountMask: '',
        mileageMask: '',
        reachStatus: '',
        percentage: '',
        devStatus: '0',
        devLog: '',
        range: '',
        selectDateVal2: '',
        selectDateVal: '',
        failedType: [],
        oilConsumptionRange: '',
        oilConsumptionMask: ''
      },
      hideExport,
      conditon: {
        time: '',
        pvovince: '',
        city: '',
        range: '',
        provCode: ''
      },
      rangeList: [
        { label: '0%', value: '0-0' },
        { label: '0-30%', value: '0-30' },
        { label: '30-50%', value: '30-50' },
        { label: '50-80%', value: '50-80' },
        { label: '80%以上', value: '80-100' }
      ],
      provinceList: [],
      tableData: [], // 表格数据
      currentPage: 1,
      total: 0,
      pageSize: 50,
      mobileReg: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
      // onDebounceSearch: _.debounce(this.onSearch, 500),
      adr: '',
      phone: '',
      isSear: true,
      isEdit: false,
      isSeeDetail: false,
      currData: ''
    }
  },
  computed: {
    // areaList() {
    //   let nerArr = JSON.parse(JSON.stringify(this.$store.getters.areaList))
    //   // if (nerArr.length > 0) {
    //   //   nerArr.forEach(item => {
    //   //     // item.provinceCode = item.provinceCode + '0000'
    //   //     item.value = item.provinceCode + '0000'
    //   //     item.label = item.provinceName
    //   //     // if (item.cityItem.length > 0) {
    //   //     //   item.cityItem.forEach(itemChen => {
    //   //     //     itemChen.provinceCode = itemChen.cityCode
    //   //     //     itemChen.provinceName = itemChen.cityName
    //   //     //   })
    //   //     // }
    //   //     // this.proptions.push({
    //   //     //   value: item.provinceCode + '0000',
    //   //     //   label: item.provinceName
    //   //     // })
    //   //   })
    //   // }
    //   if (nerArr.length == 1) {
    //     this.cardNum = Util.keyValueCardNum[nerArr[0].provinceCode]
    //   }
    //   return nerArr
    // },
    username() {
      if (this.$store.state.user.realName && this.isSear) {
        this.formData.cmpnanyDevUser = this.$store.state.user.realName
        // this.initDate(1)
        this.isSear = false
      }
      return this.$store.state.user.realName
    }
  },
  mounted() {
    this.getPrInter()
    this.initDate(1)
  },
  methods: {
    querySearchAsync(queryString, cb) {
      var results = []
      http
        .commonCardListAll({
          id: this.currRow.id,
          cardNumber: queryString
        })
        .then(e => {
          if (e.code == 200) {
            e.data.forEach(item => {
              item.value = item.cardNumber
            })
            results = e.data
            cb(results)
          }
        })
      // clearTimeout(this.timeout);
      // this.timeout = setTimeout(() => {
      // }, 3000 * Math.random());
    },
    querySearchAsynclmk(queryString, cb) {
      let results = this.qqqOption.filter(
        item => item.label.indexOf(queryString) > -1
      )
      cb(results)
    },
    handleSelectlmk(item) {
      this.form.qqq = item.value
    },
    handleSelect(item) {
      console.log(item)
      this.form.domains[0].value = item.cardNumber
      this.form.domains[0].value2 = item.cardCount
    },
    handleConfirm() {
      this.subTask('form')
    },
    changeData() {
      let commonCardDiscount = ''
      if (this.form.cardType == '1') {
        console.log('456')
        commonCardDiscount = this.currData.cbCardDiscount
        if (commonCardDiscount.cardNo) {
          this.form.qqq = commonCardDiscount.cardNo
        }
        this.form.vipDiscount = commonCardDiscount.vipDiscount.toString()
        this.form.discountType = commonCardDiscount.discountType.toString()
        this.form.remark = commonCardDiscount.remark
      } else {
        console.log('123')
        commonCardDiscount = this.currData.commonCardDiscount
        if (commonCardDiscount.cardNo) {
          this.form.domains = []
          let val = commonCardDiscount.cardNo.split('_')
          this.form.domains.push({
            value: val[0],
            value2: val[1]
          })
        }
        this.form.vipDiscount = commonCardDiscount.vipDiscount.toString()
        this.form.discountType = commonCardDiscount.discountType.toString()
        this.form.remark = commonCardDiscount.remark
      }
    },
    changeIs() {
      this.$refs.form.clearValidate()
    },
    closeProAll(curr) {
      this[curr] = false
    },
    closeTask(isSear) {
      // http
      //     .cancelReceive({
      //       id: this.currRow.id
      //     })
      //     .then((e) => {
      //       if (e.code == 200) {
      //         this.$message({
      //           message: '退订成功',
      //           type: 'success',
      //         })
      //         this.onSearch(this.currentPage)
      //         this.dialogFormVisible3 = false
      //       }
      //     })
      if (isSear) {
        this.onSearch(this.currentPage)
      }
      this.tdIs = false
    },
    is7day(row) {
      return Util.isMoreThanSevenDaysAgo(row.devStartTime)
    },
    closePro(row) {
      // this.dialogFormVisible3 = true
      this.tdIs = true
      this.currRow = row
    },
    changeSearch() {
      if (this.value1) {
        this.tableHeight1 = this.tableHeight - 120
      } else {
        this.tableHeight1 = this.tableHeight
      }
    },
    getPrev() {
      http
        .getCountyAreaList({
          code: '0',
          areaType: 'PROVINCE'
        })
        .then(e => {
          if (e.data.length > 0) {
            this.proptions = e.data.map(item => ({
              value: item.code,
              label: item.name
            }))
          }
        })
    },
    changeDetail() {
      this.isEdit = false
      this.onSearch(this.currentPage)
    },
    changeSeeDetail() {
      this.isSeeDetail = false
    },
    showVal(oldVal, newVal) {
      this.form[oldVal] = this.currRow[newVal]
    },
    async ciChange() {
      this.cuoptions = []
      this.form.cu = ''
      const { data } = await http.getCountyAreaList({
        code: this.form.ci,
        areaType: 'COUNTY'
      })
      if (data.length > 0) {
        this.cuoptions = data.map(item => ({
          value: item.code,
          label: item.name
        }))
      } else {
        this.cuoptions = this.cioptions.filter(
          item => item.value == this.form.ci
        )
      }
      this.form.cu = this.currRow.countycode
    },
    prChange() {
      this.cuoptions = []
      this.cioptions = []
      this.form.ci = ''
      this.form.cu = ''
      http
        .getCountyAreaList({
          code: this.form.pr,
          areaType: 'CITY'
        })
        .then(e => {
          if (e.data.length > 0) {
            this.cioptions = e.data.map(item => ({
              value: item.code,
              label: item.name
            }))
            this.form.ci = this.currRow.citycode
            this.ciChange()
          }
        })
    },
    subTask(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.form.failedType)
          let params = {
            contactName: this.form.contactName,
            contactPhone: this.form.contactPhone,
            devSuccess: this.form.devSuccess,
            failedType: this.form.failedType ? this.form.failedType[1] : '',
            cardType: this.form.cardType,
            vipDiscount: this.form.vipDiscount,
            discountType: this.form.discountType,
            remark: this.form.remark,
            failedRemark: this.form.remarkerr,
            companyLabel: this.form.companyLabel,
            dieselDiscountPrice: this.num,
            id: this.currRow.id
          }
          if (this.form.cardType == 2) {
            params.cardNo =
              this.form.domains[0].value + '_' + this.form.domains[0].value2
          } else {
            params.cardNo = this.form.qqq
          }
          http.devComplete(params).then(e => {
            if (e.code == 200) {
              this.$message({
                message: '开发结束资料提交成功！',
                type: 'success'
              })
              this.onSearch(this.currentPage)
              this.dialogFormVisible2 = false
            }
          })
        }
      })
    },
    async showMes(row, text) {
      if (row.devUser != this.username) {
        this.$message({
          message: '仅可' + text + '自己的资料',
          type: 'warning'
        })
        return
      }
      this.num = 0
      this.form = {
        companyLabel: '',
        companyNameMask: '',
        companyCreditCodeMask: '',
        pr: '',
        ci: '',
        cu: '',
        commonCardStatus: '',
        contactName: '',
        contactPhone: '',
        cardType: '1',
        qqq: '',
        vipDiscount: '',
        discountType: '',
        remark: '',
        domains: [
          {
            value: this.cardNum != '' ? this.cardNum : '',
            value2: ''
          }
        ]
      }
      this.currRow = row
      this.dialogFormVisible2 = true
      await this.getPrev()
      this.isShowInput = row.companyCreditCodeMask ? true : false
      this.form.companyNameMask = row.companyNameMask
      this.form.companyCreditCodeMask = row.companyCreditCodeMask
      this.form.pr = this.currRow.provcode
      this.isChangeci = this.currRow.citycode != '' ? true : false
      this.isChangecu = this.currRow.countycode != '' ? true : false
      this.prChange()
      this.getqqqOption(text)
    },
    getqqqOption(text) {
      let params = {
        id: this.currRow.id
      }
      this.qqqOption = []
      http.cardInfoAll(params).then(e => {
        if (e.code == 200) {
          if (e.data.cbCardInfo.cardNos) {
            e.data.cbCardInfo.cardNos.forEach(item => {
              this.qqqOption.push({
                value: item,
                label: item
              })
            })
          }
          const baseMees = e.data.companyInfo
          this.form.contactName = baseMees.contactName
          this.form.contactPhone = baseMees.contactPhone
          this.currData = e.data

          this.changeData()
        }
      })
      if (text == '修改') {
        http.completeInfoTar(params).then(e => {
          if (e.code == 200) {
            let nrData = e.data
            // this.form.devSuccess = nrData.devSuccess + ''
            this.$set(this.form, 'devSuccess', nrData.devSuccess + '')
            this.form.contactName = nrData.contactName
            this.form.contactPhone = nrData.contactPhone
            this.form.cardType = nrData.cardType ? nrData.cardType + '' : ''
            if (nrData.cardType == '1') {
              if (nrData.cardNo) {
                this.form.qqq = nrData.cardNo
              }
            } else {
              if (nrData.cardNo) {
                this.form.domains = []
                let val = nrData.cardNo.split('_')
                this.form.domains.push({
                  value: val[0],
                  value2: val[1]
                })
              }
            }
            this.form.vipDiscount = nrData.vipDiscount
              ? nrData.vipDiscount + ''
              : ''
            this.form.discountType = nrData.discountType
              ? nrData.discountType + ''
              : ''
            this.form.remark = nrData.remark ? nrData.remark : ''

            this.form.companyLabel = nrData.companyLabel
              ? nrData.companyLabel
              : ''
            this.num = nrData.dieselDiscountPrice

            this.form.failedType = nrData.failedType
              ? nrData.failedType + ''
              : nrData.failedType
            // this.form.remarkerr = nrData.failedRemark ? nrData.failedRemark : ''
            this.$set(this.form, 'remarkerr', nrData.failedRemark + '')
          }
        })
      }
    },
    seeDevLog(row) {
      this.devLogIs = true
      this.currRow = row
    },
    seeTopFive(row) {
      this.seeTopFiveIs = true
      this.currRow = row
    },
    toDetail(row) {
      this.dialogFormVisible = true
      this.adr = row.companyAddress
      this.phone = row.companyPhone
    },
    rulePhone(rule, value, callback) {
      let reg = this.mobileReg
      if (!value) {
        callback(new Error('请输入客户手机号码'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的客户手机号码'))
        // this.codeStatus = true
      } else {
        if (!this.time) {
          // this.codeStatus = false
        }
        callback()
      }
    },
    ruleMobile(rule, value, callback) {
      if (!value.value || !value.value2) {
        callback(new Error('请输入主卡卡号及有效卡数量!'))
      } else {
        if (!/^\d+$/.test(value.value) || !/^\d+$/.test(value.value2)) {
          callback(new Error('请输入数字!'))
        } else {
          if (value.value.length == 19) {
            callback()
          } else {
            callback(new Error('请输入主卡卡号19位数字!'))
          }
        }
      }
    },
    ruleMobile2(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入联名卡主卡卡号!'))
      } else {
        if (!/^\d+$/.test(value)) {
          callback(new Error('请输入数字!'))
        } else {
          callback()
        }
        // else {
        //   if (value.length == 19) {
        //     callback();
        //   } else {
        //     callback(new Error('请输入主卡卡号19位数字!'))
        //   }
        // }
      }
    },
    companyCred(rule, value, callback) {
      if (value) {
        if (!this.isShowInput) {
          if (!/^[A-Za-z0-9]+$/.test(value)) {
            callback(new Error('请输入正确的统一社会信用代码！'))
          } else {
            if (value.length != 18) {
              callback(new Error('请输入正确的统一社会信用代码！'))
            } else {
              callback()
            }
          }
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入正确的统一社会信用代码！'))
      }
    },
    numHave(rule, value, callback) {
      console.log(this.num)
      if (this.num || this.num === 0) {
        callback()
      } else {
        callback(new Error('请调整柴油优惠折算金额(！'))
      }
    },
    editRow(row, type) {
      if (row.devUser != this.username) {
        return
      }
      row.type = type
      this.nrData = row
      this.isEdit = true
    },
    seeRow(row) {
      this.isSeeDetail = true
      this.seeDeatailData = row
    },
    async getPrInter() {
      const { data } = await http.getCountyAreaList({
        code: '0',
        type: '1',
        areaType: 'PROVINCE'
      })
      this.areaListPr = data.map(item => ({
        value: item.code,
        label: item.name,
        leaf: false
      }))
      if (this.areaListPr.length == 1) {
        this.cardNum =
          Util.keyValueCardNum[this.areaListPr[0].value.substring(0, 2)]
      }
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const { data } = await http.getCountyAreaList({
          code,
          type: '1',
          areaType: 'CITY'
        })
        const nodes = data.map(item => ({
          value: item.code,
          label: item.name,
          leaf:
            code == '110000' ||
            code == '120000' ||
            code == '500000' ||
            code == '310000' ||
            code == '900000'
              ? true
              : false
        }))
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes)
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const { data } = await http.getCountyAreaList({
          code,
          type: '1',
          areaType: 'COUNTY'
        })
        const nodes = data.map(item => ({
          value: item.code,
          label: item.name,
          leaf: true
        }))
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes)
      })
    },
    propsData() {
      const vm = this
      return {
        lazy: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const { level, value } = node
          if (level === 1) {
            resolve(await vm.getCiInter(value, level))
          } else if (level === 2) {
            resolve(await vm.getCuInter(value, level))
          } else {
            resolve([])
          }
        }
      }
    },
    getListP(code, level) {
      return new Promise(async resolve => {
        const { data } = await http.getCountyAreaList({
          code,
          areaType: 'COUNTY'
        })
        const nodes = data.map(item => ({
          value: item.code,
          label: item.name,
          leaf: true
        }))
        resolve(nodes)
      })
    },
    getProvinceList() {
      http.carUnpetrifiedComProv().then(e => {
        if (e.code == 200 && e.data) {
          this.provinceList = e.data
        }
      })
    },
    initDate(num = 2) {
      // if (num == 2 && this.formData.time == '') {
      //   this.$message({
      //     message: '请选择月份',
      //     type: 'warning',
      //   })
      //   return
      // }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = {
        time: this.formData.time,
        page: this.currentPage,
        pageSize: this.pageSize,
        provCode: this.formData.provCityCounty[0] || '',
        cityCode: this.formData.provCityCounty[1] || '',
        countyCode: this.formData.provCityCounty[2] || '',
        companyName: this.formData.companyName,
        // devUser: this.formData.cmpnanyDevUser,
        reachStatus: this.formData.reachStatus,
        cardType: this.formData.cardType,
        vehicleCountMask: this.formData.vehicleCountMask,
        mileageMask: this.formData.mileageMask,
        percentage: this.formData.percentage,
        devStatus: this.formData.devStatus,
        isRecord: this.formData.devLog,
        companyCardStatus:
          this.formData.companyCardStatus.length > 0
            ? this.formData.companyCardStatus.join(',')
            : '',
        devStartTimeBegin: this.formData.selectDateVal
          ? new Date(this.formData.selectDateVal[0] + ' 00:00:00').getTime()
          : '',
        devStartTimeEnd: this.formData.selectDateVal
          ? new Date(this.formData.selectDateVal[1] + ' 23:59:59').getTime()
          : '',
        devEndTimeBegin: this.formData.selectDateVal2
          ? new Date(this.formData.selectDateVal2[0] + ' 00:00:00').getTime()
          : '',
        devEndTimeEnd: this.formData.selectDateVal2
          ? new Date(this.formData.selectDateVal2[1] + ' 23:59:59').getTime()
          : '',
        failedType:
          this.formData.failedType && this.formData.failedType.length > 0
            ? this.formData.failedType[1]
            : '',
        oilConsumptionRange: this.formData.oilConsumptionRange || '',
        oilConsumptionMask: this.formData.oilConsumptionMask || ''
      }
      // 初始化数据
      // this.tableData = []
      http.targetFindPage(params).then(e => {
        loading.close()
        if (e.code == 200 && e.data.pageInfo && e.data.pageInfo.dataList) {
          if (e.data.time) {
            this.formData.time = e.data.time
          }
          e.data.pageInfo.dataList.forEach(item => {
            Object.keys(item).forEach(item2 => {
              if (item2 != 'citycode' && item2 != 'countycode') {
                item[item2] =
                  item[item2] || item[item2] === 0 ? item[item2] : '-'
              }
            })
          })
          this.tableData = e.data.pageInfo.dataList.map(_ => {
            _.decryptedCompanyName = false
            _.companyCreditCodeIs = false
            _.cmpnanyDevStartTime =
              _.devStartTime != '-'
                ? Util.format(
                    new Date(_.devStartTime * 1).getTime(),
                    'yyyy-MM-dd'
                  )
                : '-'
            _.cmpnanyDevEndTime =
              _.devEndTime != '-'
                ? Util.format(
                    new Date(_.devEndTime * 1).getTime(),
                    'yyyy-MM-dd'
                  )
                : '-'
            _.companyCardStatusText = this.getNmae(
              Util.companyCardStatusOption,
              _.companyCardStatus
            )
            _.companyDevStatusText = this.getNmae(
              Util.devStatusOption,
              _.devStatus.toString()
            )
            _.cardTypeText = this.getNmae(Util.cardTypeOption, _.cardType)
            _.reachStatusText = this.getNmae(
              Util.reachStatusOptions,
              _.reachStatus
            )
            _.failedTypeText = '-'
            if (_.failedKind) {
              _.failedTypeText =
                this.getNmae(Util.failedKindOption, _.failedKind) + ' / '
            }
            if (_.failedType) {
              _.failedTypeText =
                _.failedTypeText +
                this.getNmae(Util.failedTypeOption, _.failedType)
            }
            return _
          })
          this.total = e.data.pageInfo.total
          this.currentPage = e.data.pageInfo.pageNum
        } else {
          this.tableData = []
        }
      })
    },
    handleCurrentChange(index) {
      this.currentPage = index
      this.initDate(2)
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.initDate(2)
    },
    getNmae(allData, val) {
      let curr = allData.filter(item => {
        return item.value == val
      })
      if (curr.length > 0) {
        return curr[0].label
      } else {
        return '-'
      }
    },
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
    onSearch(val) {
      console.log('test')
      this.currentPage = val ? val : 1
      this.total = 0
      this.initDate(2)
    },
    onPrev() {
      // 返回上级
      this.$router.push({
        name: 'carStopBrand'
      })
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    handleBatchReturn() {
      if (this.selectedRows.length === 0) {
        this.$message({
          message: '请至少选择一条数据',
          type: 'warning'
        })
        return
      }
      this.batchReturnIs = true
    },
    closeBatchReturn(isSear) {
      if (isSear) {
        this.onSearch(this.currentPage)
        this.selectedRows = []
        // 清空表格选择
        this.$nextTick(() => {
          if (this.$refs.table) {
            this.$refs.table.clearSelection()
          }
        })
      }
      this.batchReturnIs = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.proTextSty {
  font-size: 14px;
}

.tableTitleSty {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  margin-top: 10px;
}

.benAllSty {
  display: flex;

  .itemDiv {
    margin-right: 10px;

    &:first-child {
      margin-left: 20px;
    }
  }
}

.searchBtn {
  background: #41B883;
  color: #ffffff;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

/deep/ .el-input-number--medium {
  line-height: 30px;
}

.formSty {
  /deep/ .el-form-item__label {
    line-height: 20px;
  }

  /deep/ .el-input--medium .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 32px;
}

/deep/ .el-dialog__body {
  padding: 20px 0 20px 30px;
  border-bottom: 2px solid #EEEEEE;
}

/deep/ .el-table__empty-block {
  width: 100% !important;
}

/deep/ .el-dialog__header {
  padding: 0;
  background: rgba(52, 109, 176, 0.06);
  border-radius: 2px 2px 0px 0px;

  .el-dialog__title {
    display: block;
    line-height: 56px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
    font-style: normal;
    padding-left: 30px;
  }
}

.btn_Sub {
  width: 64px;
  line-height: 33px;
  background: #336EB0;
  border-radius: 2px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  font-style: normal;
  padding: 0;
}

.btn_Clo {
  width: 64px;
  line-height: 33px;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  font-style: normal;
  padding: 0;
  margin-left: 8px;
}

.car-unpetrified-com {
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }

  .block {
    display: flex;

    .center {
      margin: 10px auto;
    }
  }
}
</style>
